<template>
  <div class="payment-dialog-content input-text-size">
    <Loader v-if="fortePaymentSuscessFlag"/>
  <v-row class="row">
  <v-col cols="2" class="pt-0 pb-0 ma-0">
    <v-text-field
    class="input-text-size payment-dialog-fiscal-year"
    id="paymentDialogFiscalYear"
     :value="editedItem.fiscalYear"
    label="Fiscal Year" readonly tabindex="-1">
   </v-text-field>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0 ma-0">
      <ClarionDateControl
        class="input-text-size payment-dialog-business-date"
        id="paymentDialogBusinessDate"
        label="Payment(Business) Date"
        :isToggle="false" :rules="businessRules" v-model="editedItem.payDate"
        :isDisabled="checkIfTaxDetailsPosted()" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
    <v-text-field
      class="input-text-size payment-dialog-payment-number"
      id="paymentDialogPaymentNumber"
     :value="editedItem.paymentNumber"
    label="Payment #" readonly tabindex="-1" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
    <v-select class="input-text-size" id="tax-check-recon-criteria-wkst"
      label="Workstation #" v-model="editedItem.workstation"
      :items="getPaymentWkstNumList()" :readonly="checkIfTaxDetailsPosted()"
      :tabindex="checkIfTaxDetailsPosted() ? -1 : 0" />
    </v-col>
  </v-row>
  <v-row class="row">
    <v-col cols="2" class="pt-0 pb-0 ma-0">
    <v-text-field class="input-text-size payment-dialog-total-due"
      id="paymentDialogTotalDue"
      :value="totalSum" readonly tabindex="-1"
      :key="changeKeyOnDialog"
      label="Total Due" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <v-text-field class="input-text-size payment-dialog-total-paid" readonly tabindex="-1"
      id="paymentDialogTotalPaid" :key="changeKeyOnDialog"
    :value="totalPaidMain" label="Total Paid" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
    <v-text-field class="input-text-size payment-dialog-cash-change"
      id="paymentDialogChangeDue"
     v-model="editedItem.cashChange" label="Change Due" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0 ma-0">
    <v-text-field class="input-text-size" label="Paid By" :value="getPaidBy()" />
    </v-col>
    </v-row>
  <v-row v-if="editedItem.createdBy || editedItem.createdWhen">
    <v-col cols="4" class="pt-0 pb-0 ma-0">
    <v-text-field
      class="input-text-size payment-dialog-created-by"
      id="paymentDialogCreatedBy"
      :value="editedItem.createdBy"
      label="User Name" readonly tabindex="-1" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0 ma-0">
    <v-text-field
      class="input-text-size payment-dialog-created-when"
      id="paymentDialogCreatedWhen"
      :value="createdWhenDisplay"
      label="Date/Time" readonly tabindex="-1" />
    </v-col>
    </v-row>
  <v-row>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <v-checkbox label="Void" @change="isVoidChecked"
      v-model="editedItem.isVoid" :disabled="editedItem.isVoid" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <v-checkbox label="Mail" v-model="editedItem.mail" />
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <v-switch class="mt-0"
       :value="halfOrPostmark.dialogPostmark"
        :label="halfOrPostmark.dialogPostmark ? 'Postmark Ok' : 'Normal'"
         @change="val => onChangeHalfOrPostmark(val, 'dialogPostmark')"
        color="primary"
        dense
        hide-details>
        </v-switch>
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <v-switch
      :value="halfOrPostmark.dialogHalf"
        :label="halfOrPostmark.dialogHalf ? 'Half Pay' : 'Full Pay'"
         @change="val => onChangeHalfOrPostmark(val, 'dialogHalf')"
      class="mt-0"
      color="primary"
      dense
      hide-details
      ></v-switch>
    </v-col>
    <v-col cols="2" class="pt-0 pb-0 ma-0">
      <ClarionDateControl class="input-text-size payment-dialog-penalty-date"
      id="paymentDialogPenaltyDate"
      label="Penalty Date"
      :isToggle="false" v-model="editedItem.penaltyDate" @input="handlePenDateInput" />
    </v-col>
  </v-row>
    <!-- <template>
      <dialogTaxDetails
        ref="dialogTaxDetailsRef"
        v-model="editedItem.taxDetails"
        :baseCrudKey="baseCrudKey"
        :fiscalYear="editedItem.fiscalYear"
        :loadMoreTaxBtn="editedItem.loadMoreTax" />
    </template> -->
    <template v-if="checkIfTaxDetailsPosted() && editedItem.taxDetails.length >= 30">
      <div class="large-payment-wrapper">
        <LargePaymentList
          ref="largePaymentListRef"
          :key="`large-payment-${editedItem.paymentNumber || 'new'}-${editedItem.fiscalYear || ''}`"
          :fiscalYear="editedItem.fiscalYear"
          :paymentNumber="editedItem.paymentNumber"
          :taxDetails="editedItem.taxDetails"
          :totalDue="totalSum"
          :totalPaid="totalPaidMain"
          :cashChange="editedItem.cashChange"
          :totalSumMethod="totalSum"
          @totalChanged="handleTotalChanged"
          @taxDetailsChanged="handleTaxDetailsChanged"
          @serverTotalsChanged="handleServerTotalsChanged"
          :checkIfTaxDetailsPosted="checkIfTaxDetailsPosted()" />
      </div>
    </template>
    <template v-else-if="baseCrudKey !== 'pickListMakePaymentDialog' &&
     ((editedItem.paymentNumber|| 0) === 0)">
      <dialogTaxDetails
        ref="dialogTaxDetailsRef"
        v-model="editedItem.taxDetails"
        :baseCrudKey="baseCrudKey"
        :fiscalYear="editedItem.fiscalYear"
        :loadMoreTaxBtn="editedItem.loadMoreTax"
        :isItFromJuneResale="isItFromJuneResale"
        :selectedComponentCriteria="selectedComponentCriteria"
        @selectionChanged="handleTaxDetailsSelectionChange" />
    </template>
    <template v-else>
      <div class="large-payment-wrapper">
        <LargePaymentList
          ref="largePaymentListRef"
          :key="largePaymentKey"
          :fiscalYear="editedItem.fiscalYear"
          :paymentNumber="editedItem.paymentNumber"
          :taxDetails="editedItem.taxDetails"
          :totalDue="totalSum"
          :totalPaid="totalPaidMain"
          :cashChange="editedItem.cashChange"
          :totalSumMethod="totalSum"
          @totalChanged="handleTotalChanged"
          @taxDetailsChanged="handleTaxDetailsChanged"
          @serverTotalsChanged="handleServerTotalsChanged"
          :checkIfTaxDetailsPosted="checkIfTaxDetailsPosted()" />
      </div>
    </template>
    <dialogPaymentDetails id="miscEditDialogPaymentDetails"
      class="misc-edit-dialog-payment-details input-text-size"
      toolbarTitle="Payment Details"
      ref="paymentDetailsRef"
      v-model="editedItem.paymentDetails"
      :isTotal="true"
      :cmnEnums="cmnEnums"
      :defaultForteConfig="defaultForteConfig"
      :amount="totalSum"
      :taxPaymentRecord="editedItem"
      :showOverUnder="showOverUnder"
      :showPennyRound="showPennyRound"
      :showOverpayment="showOverpayment"
      :overpaymentAmt="overpaymentAmt"
      :programType="'TAX'"
      @totalPaymentAmount="totalPaymentAmount"
      @overUnderPayClicked="overUnderPayClicked"
      @pennyRoundClicked="pennyRoundClicked"
      @overpaymentClicked="overpaymentClicked"
      @paymentFieldActivity="handlePaymentFieldActivity" />
    <CommonPopUp v-model="showFiscalYearErrorMsg" v-if="showFiscalYearErrorMsg"
      :enableFlashTypeMsg="false">
      <template v-slot:customsLabelOrInfo>
        <h3 class="mt-3">Cannot move to different Fiscal year</h3>
        <p class="mt-3">This payment transaction was created in FY {{ editedItem.fiscalYear }},
          and cannot be moved to different Fiscal year.
          Please void or cancel the transaction and re-enter it in the desired fiscal year.
        </p>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="closeFiscalYearErrorMsg()">OK</v-btn>
      </template>
    </CommonPopUp>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import dialogPaymentDetails from './dialogPaymentDetails.vue';
import dialogTaxDetails from './dialogTaxDetails.vue';
// import LargePaymentTransactionList from '
// ../../../../views/tax/payments/largePayments/largePaymentTransactionList.vue';
import '../../../../assets/style.css';
import { isFiscalYearWithinPostingPeriod, toFiscalYear, toShortDate } from '../../../../util/shared/tmc-global';
import {
  amountFormat,
  amountToNumber,
  isAltP,
  isAltR,
  isFnTenKey,
  isInsert,
  isTaxOrPayFnKey,
  toLocalDateTime,
} from '../../../../util/shared/vue-global';
import LargePaymentList from '../../../../views/tax/payments/largePayments/LargePaymentList.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import { getFeeListBasedOnEffeciveDate, getPreviousPenaltyPeriodEnd } from '../../common-utils/CommonTaxFunctionalities';
import { commonVoidFunc } from '../../common-utils/CommonTaxPaymentFunctionalities';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import Loader from '../../common-utils/loader.vue';
import {
  exemptManufacturingStatusCode,
  needsPennyRounding,
  parseLocalDate,
  penaltyCalculation,
  pennyRoundingFeeAmount,
} from '../../common-utils/tax-common.util';

export default {
  props: {
    baseCrudKey: {
      type: String,
      default: 'paymentTransactionList',
    },
    attachmentConstants: {
      type: Object,
      default: () => { },
    },
    isItFromJuneResale: {
      type: Boolean,
      default: false,
    },
    selectedComponentCriteria: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      delayTimerId: null,
      totalPaidMain: 0.00,
      showOverUnder: false,
      showPennyRound: false,
      showOverpayment: false,
      remainingBalance: 0,
      showFiscalYearErrorMsg: false,
      hasSelectedTaxDetails: false,
      selectedTaxDetailIds: [], // Store selected item IDs to preserve selection
      // Server totals from LargePaymentList (accurate across all pages)
      serverTotalDue: null,
      changeKeyOnDialog: 1,
      defaultForteConfig: {
        configScope: 'paymentConfig',
        isRequiredForte: true,
      },
      prePostmarkPenaltyDate: null,
    };
  },
  components: {
    dialogTaxDetails,
    CommonPopUp,
    dialogPaymentDetails,
    ClarionDateControl,
    // LargePaymentTransactionList,
    LargePaymentList,
    Loader,
  },
  created() {
    window.addEventListener('keydown', this.handlePayShortCut);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handlePayShortCut);
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      nextReceiptNumber: (state) => state.misc.miscTransaction.nextReceiptNumber,
      cmnEnums: (state) => ({
        cmnPaymentTypes: state.enums.TaxPaymentTypeEnum || [],
        cmnEFTTypes: state.enums.MISCEFTTypeEnum || [],
        cmnCardTypes: state.enums.MISCCardTypeEnum || [],
      }),
      fortePaymentSuscessFlag: (state) => state.ForteService.fortePaymentSuscessFlag,
      paymentWkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem || {},
      nextTransNumber: (state) => state.common.cmnTransNumber.nextTransNumber,
      transNoPulse: (state) => state.common.cmnTransNumber.transNoPulse,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      taxFeeList: (state) => state.base.crud.items.sharedTaxFeeMaster,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      paymentShotCutStore: (state) => state.tax.taxPayment.paymentShotCutStore,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
    }),
    ...mapState('tax/ccPayments', ['paymentSuccessFlag']),
    editedItemProp() {
      return this.editedItem;
    },
    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    totalSum() {
      // If we have server totals from LargePaymentList (for paginated data), use them
      if (this.serverTotalDue !== null) {
        return amountFormat(this.serverTotalDue || 0);
      }

      // Fallback: Calculate from current taxDetails (for non-paginated or picklist mode)
      let total = 0;
      if (this.editedItem.taxDetails && this.editedItem.taxDetails.length > 0) {
        // Include items that are TAXPAYMENT or don't have taxType set (new items)
        total = this.editedItem.taxDetails
          .reduce((acc, item) => {
            if (!item.taxType || item.taxType === 'TAXPAYMENT') {
              return acc + amountToNumber(item.total || 0);
            }
            return acc;
          }, 0);
      }
      return amountFormat(total || 0);
    },
    businessRules() {
      return [
        (v) => !!v || 'Required.',
        (v) => !v || isFiscalYearWithinPostingPeriod(toFiscalYear(parseLocalDate(v))) || 'The Date results in a fiscal year outside the current posting period',
      ];
    },
    isVisibleProp: {
      get() {
        return this.isVisible(this.baseCrudKey);
      },
    },
    largePaymentKey() {
      // Use a stable key that doesn't change when tax details are modified
      // This prevents Vue from re-creating the component and losing serverTotals state
      const fiscalYear = this.editedItem.fiscalYear || '';
      const paymentNumber = this.editedItem.paymentNumber || 'new';
      return `large-payment-picklist-${fiscalYear}-${paymentNumber}`;
    },
    createdWhenDisplay() {
      const when = this.editedItem.createdWhen;
      return when ? toLocalDateTime(when) : '';
    },
    overpaymentAmt() {
      const details = this.editedItem.paymentDetails || [];
      for (let i = 0; i < details.length; i += 1) {
        if (details[i].overpaymentAmt) {
          return details[i].overpaymentAmt;
        }
      }
      return 0;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
      'setItems',
      'setIsVisible',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setHalfOrPostmark',
      'setPaymentShotCutStore',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadMoreTax',
    ]),
    getPaymentWkstNumList() {
      if ((this.paymentWkstNumList || []).length) {
        const currentWorkstation = Number(this.editedItem.workstation) || null;
        // if the workstation is already in the list, return the list
        if (this.paymentWkstNumList.includes(currentWorkstation)) {
          return this.paymentWkstNumList;
        }
        // if the workstation is not in the list and is not null/undefined, add it to the list
        if (currentWorkstation != null) {
          const combinedList = [...this.paymentWkstNumList, currentWorkstation];
          combinedList.sort((a, b) => a - b);
          return combinedList;
        }
        return this.paymentWkstNumList;
      } return [];
    },
    checkIsUndefined() {
      if (this.editedItem.paymentDetails && this.editedItem.paymentDetails.length > 0) return true;
      return false;
    },
    openDialog() {
      this.isVisibleProp = true;
      this.$nextTick(() => {
        if (this.$refs.dialogTaxDetailsRef) {
          const hasValues = this.$refs.dialogTaxDetailsRef.hasValues();
          if (!hasValues) {
            this.$refs.dialogTaxDetailsRef.addOne();
          }
        }
      });
    },
    handlePayShortCut(e) {
      const dialogIsOpenOrNot = this.isVisible(this.baseCrudKey);
      if (dialogIsOpenOrNot) {
        const isInsertRes = isInsert(e) || isTaxOrPayFnKey(e);
        const isInsertR = isAltR(e) || isFnTenKey(e); // to Save & Print Receipt
        const isInsertP = isAltP(e); // jumps the cursor to the bottom payment section.
        const isTaxOrPayFnKeyRes = isTaxOrPayFnKey(e);
        if (isTaxOrPayFnKeyRes) e.preventDefault();
        // checking for F11 or ins keys
        if (isInsertRes || isTaxOrPayFnKeyRes) {
          // check which to add is it payment or tax record
          if (this.paymentShotCutStore.paymentAddIconStatus) {
            this.setPaymentShotCutStore({ res: this.paymentShotCutStore.isItPayRecordNCounter + 1, whichOne: 'isItPayRecordNCounter' });
          } else this.setPaymentShotCutStore({ res: this.paymentShotCutStore.isItTaxRecordNCounter + 1, whichOne: 'isItTaxRecordNCounter' });
        }
        if (isInsertP) {
          const defaultPayItem = {
            paymentType: '',
            amount: 0,
            paidBy: '',
          };
          // if there is no payment-details adding one
          if (!this.editedItem.paymentDetails.length) {
            this.editedItem.paymentDetails = [defaultPayItem];
          }
          this.$refs.paymentDetailsRef.highlightTypeFunc(this.editedItem.paymentDetails.length
           || 0);
          // pointing to payment-details, used to highlight plus icon
          this.setPaymentShotCutStore({ res: true, whichOne: 'paymentAddIconStatus' });
        }
        if (isInsertR) this.$emit('callFromPayDialog', true);
      }
    },
    isVoidChecked() {
      if (!this.editedItem.isVoid) return;
      const retVoidFormat = commonVoidFunc({ ...this.editedItem });
      this.editedItem = retVoidFormat;
      this.syncTaxRowsToGrid(retVoidFormat.taxDetails);
    },
    /**
     * Pushes rows the header rewrote into LargePaymentList. In list mode the grid renders its
     * own copy of the rows (crud key 'largePaymentList'), so rewriting editedItem.taxDetails
     * alone leaves the grid showing - and re-emitting - the pre-change amounts. The old
     * dialogTaxDetails grid never needed this: it is v-model bound to editedItem.taxDetails.
     */
    syncTaxRowsToGrid(taxDetails) {
      const { largePaymentListRef } = this.$refs;
      if (largePaymentListRef && typeof largePaymentListRef.syncRowsFromPayment === 'function') {
        largePaymentListRef.syncRowsFromPayment(taxDetails);
        return;
      }
      // No grid to re-seed (dialogTaxDetails branch) - drop the cached server total so
      // totalSum falls back to summing the rewritten rows.
      this.serverTotalDue = null;
    },
    checkPayDateFiscalYear(val) {
      if (!val || !this.isValidCompleteDate(val)) return;
      const changeYear = toFiscalYear(new Date(val));
      if (changeYear !== this.editedItem.fiscalYear) {
        this.showFiscalYearErrorMsg = true;
        this.editedItem.payDate = null;
      }
    },
    closeFiscalYearErrorMsg() {
      this.showFiscalYearErrorMsg = false;
    },
    checkIfTaxDetailsPosted() {
      if (((this.editedItem || {}).taxDetails || []).length) {
        const isAllPosted = this.editedItem.taxDetails.every((ft) => ft.posted);
        return isAllPosted;
      } return false;
    },
    isValidCompleteDate(dateStr) {
      // Check if date string is complete and valid (MM-DD-YYYY format)
      if (!dateStr || typeof dateStr !== 'string') {
        return false;
      }

      // Check for MM-DD-YYYY pattern (complete date)
      const datePattern = /^\d{1,2}-\d{1,2}-\d{4}$/;
      if (!datePattern.test(dateStr)) {
        return false;
      }

      // Try to parse the date to ensure it's valid
      try {
        const parts = dateStr.split('-');
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        // Basic validation
        if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) {
          return false;
        }

        // Create date object to validate
        const date = new Date(year, month - 1, day);
        return date.getFullYear() === year
          && date.getMonth() === month - 1
          && date.getDate() === day;
      } catch (e) {
        return false;
      }
    },
    handlePenDateInput(val) {
      // Ensure the penalty date is updated in the store immediately
      // Get current item from store
      const currentItem = this.item(this.baseCrudKey);
      // Force update the store with new penalty date
      this.setItem([this.baseCrudKey, {
        ...currentItem,
        penaltyDate: val,
      }]);
      // Then call the existing handlePenChange
      this.handlePenChange(val);
    },
    handlePenChange(val) {
      clearTimeout(this.delayTimerId);
      if ((val && (val).includes('-')) || !val) {
        this.delayTimerId = setTimeout(async () => {
          // For pick list payments, recalculate penalties locally for all records
          if (this.baseCrudKey === 'pickListMakePaymentDialog'
            && this.$refs.largePaymentListRef
            && !this.editedItem.paymentNumber) {
            // Validate that we have a complete date before recalculating
            if (!val || !this.isValidCompleteDate(val)) {
              return; // Don't recalculate with incomplete date
            }

            // Call the new method to recalculate penalties locally
            this.$refs.largePaymentListRef.recalculatePenaltiesForPicklist(val);
            return; // Exit early, local recalculation handled
          }

          const selectedItems = (this.editedItem.taxDetails || [])
            .filter((item) => item.selected);
          if (selectedItems.length > 0) {
            this.calculatePenaltyForSelectedRecords(selectedItems);
            return;
          }

          // }

          // Update penalty for last added tax details record only (when no records are selected)
          // eslint-disable-next-line no-unreachable
          const { penaltyDate, penaltyRate } = this.taxSettingItem;
          const taxDetails = [...(this.editedItem.taxDetails || [])];
          // Find the last added (newest) tax details record that is not posted
          let lastAddedIndex = -1;
          // eslint-disable-next-line no-plusplus
          for (let i = taxDetails.length - 1; i >= 0; i--) {
            if (!taxDetails[i].posted && taxDetails[i].totalTax) {
              lastAddedIndex = i;
              break;
            }
          }

          // Update penalty only for the last added record
          if (lastAddedIndex >= 0) {
            const item = taxDetails[lastAddedIndex];
            const isExemptManufacturing = (item.statusCode || [])
              .includes(exemptManufacturingStatusCode);
            const updatedItem = { ...item };
            const isItAExemptPayment = updatedItem.isExempt;
            let returnedVal = { penaltyAmt: amountFormat(0) };

            if (!isItAExemptPayment) {
              returnedVal = penaltyCalculation(
                val, updatedItem.penaltyStartDate, penaltyDate, updatedItem.totalTax,
                updatedItem.totalPaid, 0, penaltyRate, updatedItem.taxTotalDue,
                updatedItem.taxYear, (item.statusCode || []), this.taxSettingItem,
              );
            }

            updatedItem.penaltyAmt = amountFormat(returnedVal.penaltyAmt);

            // Update feelist based on effective date
            let totalFee = updatedItem.totalFees;
            if ((updatedItem.allFeesList || []).length && !isExemptManufacturing) {
              // eslint-disable-next-line max-len
              const { feeDet, feesAmt } = getFeeListBasedOnEffeciveDate(updatedItem.allFeesList, val);
              totalFee = feesAmt;
              updatedItem.fees = feeDet;
              updatedItem.initialFees = feeDet;
            }
            updatedItem.totalFees = isExemptManufacturing ? 0 : amountFormat(totalFee);

            // Update total amount
            const totalCaclAmt = amountToNumber(returnedVal.penaltyAmt)
              + amountToNumber(updatedItem.taxAmt) + amountToNumber(totalFee);
            updatedItem.total = amountFormat(amountToNumber(totalCaclAmt || 0));

            // Update only the last added record in the array
            taxDetails[lastAddedIndex] = updatedItem;
          }

          this.editedItem.taxDetails = taxDetails;
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    onChangeHalfOrPostmark(val, whichOne) {
      let isItNull = false;
      if (val) isItNull = val;
      if (whichOne === 'dialogPostmark') {
        if (val) {
          // Save the pre-toggle value so turning postmark back off can restore it
          // exactly, rather than re-deriving it and risking drift.
          this.prePostmarkPenaltyDate = this.editedItem.penaltyDate;
          const penDate = getPreviousPenaltyPeriodEnd(
            this.editedItem.penaltyDate, this.taxSettingItem.penaltyDate,
          );
          this.handlePenChange(penDate);
          this.editedItem.penaltyDate = toShortDate(penDate);
        } else {
          const penDate = this.prePostmarkPenaltyDate || toShortDate();
          this.prePostmarkPenaltyDate = null;
          this.handlePenChange(penDate);
          this.editedItem.penaltyDate = toShortDate(penDate);
        }
      }
      this.setHalfOrPostmark({ res: isItNull, whichOne });
    },
    getPaidBy() {
      const item = this.editedItem;
      if (item.paymentDetails && item.paymentDetails.length) {
        return item.paymentDetails[0].paidBy;
      }
      return '';
    },
    getTaxFeeDescription(feeNumber) {
      const match = (this.taxFeeMasterData || []).find((ft) => ft.feeNumber === feeNumber);
      return match ? match.feeDescription : null;
    },
    /**
     * Writes `mergedFees` onto the FIRST tax detail - initialFees too, so no audit record is
     * created - re-totals that row, syncs the large-payment store when it is in play, and
     * returns the payment's recalculated total due.
     *
     * Shared by the two buttons that balance a payment with a fee (Over/Under and Penny
     * Round); each settles change due / remaining balance its own way afterwards.
     */
    commitFirstTaxDetailFees(mergedFees) {
      // Only the paginated large list drives totals off the server; elsewhere totalSum is
      // computed live from taxDetails. Pinning serverTotalDue in that second case froze the
      // total, so a later edit (deleting this very fee in Edit Fees) left the screen showing
      // the pre-edit figure - and the Penny Round button judging against it.
      const isServerDriven = this.serverTotalDue !== null;
      const item = this.editedItem.taxDetails[0];
      this.editedItem.taxDetails[0].initialFees = mergedFees;
      this.editedItem.taxDetails[0].fees = mergedFees;

      const feeAmt = (mergedFees || [])
        .reduce((accumulator, itm) => accumulator + amountToNumber(itm.feeAmount), 0);
      this.editedItem.taxDetails[0].totalFees = amountToNumber(feeAmt);
      // calculate totalDue
      const totalCaclAmt = amountToNumber(item.penaltyAmt)
          + amountToNumber(item.taxAmt) + amountToNumber(feeAmt);
      this.editedItem.taxDetails[0].total = amountFormat(totalCaclAmt || 0);

      // Sync updates with LargePaymentList store if it's being used
      const isUsingLargePaymentList = this.checkIfTaxDetailsPosted()
        || this.baseCrudKey === 'pickListMakePaymentDialog';
      if (isUsingLargePaymentList) {
        // Update the largePaymentList store items
        this.setItems(['largePaymentList', [...this.editedItem.taxDetails]]);
        // Also update the parent store item
        this.setItem([this.baseCrudKey, { ...this.editedItem }]);
      }

      // Recalculate totals - reset serverTotalDue to force recalculation from taxDetails
      this.serverTotalDue = null;

      // Recalculate total from all taxDetails
      const newTotalSum = this.editedItem.taxDetails
        .reduce((acc, taxItem) => {
          if (!taxItem.taxType || taxItem.taxType === 'TAXPAYMENT') {
            return acc + amountToNumber(taxItem.total || 0);
          }
          return acc;
        }, 0);

      // Hand the recalculated value back to the server-driven total, or leave it null so
      // totalSum keeps tracking taxDetails as the clerk edits them.
      this.serverTotalDue = isServerDriven ? newTotalSum : null;
      return newTotalSum;
    },
    overUnderPayClicked() {
      const feeNumber = this.taxSettingItem.overUnderFee || null;
      const feeDesc = this.getTaxFeeDescription(feeNumber);
      if (this.editedItem.taxDetails && this.editedItem.taxDetails.length) {
        // only need the difference fee to  1st tax-record
        const prevTaxDet = this.editedItem.taxDetails[0].fees || [];
        const feeObj = {
          feeAmount: amountToNumber(this.remainingBalance),
          feeDescription: feeDesc,
          feeMongoId: null,
          feeNumber,
        };
        const newTotalSum = this.commitFirstTaxDetailFees([...prevTaxDet, feeObj]);

        // Recalculate remaining balance and hide the over/under button
        this.remainingBalance = amountToNumber(this.totalPaidMain) - newTotalSum;
        this.showOverUnder = false;
        // Clerk chose Over/Under instead of change due - clear any auto-set change amount
        this.editedItem.cashChange = 0;

        // Force UI update
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    // Oklahoma no longer allows pennies in the change handed back, so a cash total that is not
    // on a nickel gets a small +/- fee (like Over/Under, but with a computed amount) to move it
    // onto one. The fee goes on the FIRST tax detail; the receipt prints it as a fee line.
    pennyRoundClicked() {
      if (!this.editedItem.taxDetails || !this.editedItem.taxDetails.length) return;
      const feeNumber = this.getPennyRoundingFeeNumber();
      // Belt and braces - the button is already hidden when the county configured no fee.
      if (!feeNumber) return;

      // Re-derive from the total WITHOUT any penny fee this dialog already added: if the amount
      // due moved after the first click, the stale fee is part of the current total, so leaving
      // it in place would round against an amount that already carries a correction.
      const prevTaxDet = this.editedItem.taxDetails[0].fees || [];
      const isPriorPennyFee = (ft) => ft.feeNumber === feeNumber && ft.feeCreatedAtpayment;
      const keptFees = prevTaxDet.filter((ft) => !isPriorPennyFee(ft));
      const priorPennyAmt = prevTaxDet.filter(isPriorPennyFee)
        .reduce((acc, ft) => acc + amountToNumber(ft.feeAmount), 0);
      const baseTotal = amountToNumber(this.totalSum) - priorPennyAmt;

      const feeAmount = pennyRoundingFeeAmount(baseTotal);
      const mergedFees = feeAmount === 0 ? keptFees : [...keptFees, {
        feeAmount,
        feeDescription: this.getTaxFeeDescription(feeNumber),
        feeMongoId: null,
        feeNumber,
        feeCreatedAtpayment: true,
      }];

      this.commitFirstTaxDetailFees(mergedFees);

      // Re-run the payment-line evaluation so Change Due lands on the rounded total, and so
      // Over/Under is judged against that rounded total rather than the original one.
      this.totalPaymentAmount(this.totalPaidMain);

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // Whatever fee the county picked in Tax Settings -> Penny Rounding Fee # is the fee the
    // button writes. Null when the setting is empty, which suppresses the button entirely
    // rather than inventing a fee number the county never chose. Tax Settings pre-fills the
    // seeded 555 (see applyDefaultFeeNumbers), so "empty" means a county that never set it.
    getPennyRoundingFeeNumber() {
      return (this.taxSettingItem || {}).pennyRoundingFee || null;
    },
    // Cash change can no longer include pennies, so Penny Round is offered only on a plain
    // cash tender whose total is off a nickel and which still has change to hand back.
    evaluatePennyRound() {
      const paymentDetails = (this.editedItem || {}).paymentDetails || [];

      // Straight cash only. A row with no type picked yet is ignored so an empty placeholder
      // does not suppress the button, but a second *typed* row - cash + check, or two cash
      // rows - does: the tender is no longer a single cash payment.
      const tenders = paymentDetails.filter((ft) => ft.paymentType);
      const isCashOnly = tenders.length === 1 && tenders[0].paymentType === 'CASH';

      // Summed here rather than read off totalPaidMain, which is only refreshed by the
      // totalPaymentAmount emit - this method also runs from the paymentDetails watcher.
      const paid = paymentDetails.reduce((acc, ft) => acc + amountToNumber(ft.amount), 0);
      // An exact tender hands back no change, so there are no pennies to avoid.
      const isSettled = Math.round((paid - amountToNumber(this.totalSum)) * 100) === 0;

      // No fee configured means there is nothing to book the rounding against.
      const hasConfiguredFee = Boolean(this.getPennyRoundingFeeNumber());

      this.showPennyRound = isCashOnly && !isSettled && hasConfiguredFee
        && needsPennyRounding(this.totalSum);
    },
    overpaymentClicked() {
      const overpaymentAmt = Math.abs(amountToNumber(this.remainingBalance));
      if (overpaymentAmt > 0 && this.editedItem.paymentDetails) {
        const checkIndex = this.editedItem.paymentDetails
          .findIndex((pd) => pd.paymentType === 'CHECK');
        if (checkIndex >= 0) {
          // Use spread to ensure Vue 2 reactivity is triggered
          const updatedPaymentDetails = this.editedItem.paymentDetails.map((pd, i) => (
            i === checkIndex ? { ...pd, overpaymentAmt } : pd
          ));
          this.editedItem = { ...this.editedItem, paymentDetails: updatedPaymentDetails };
        }
        this.showOverpayment = false;
      }
    },
    totalPaymentAmount(val) {
      this.totalPaidMain = amountFormat(val);
      const item = this.editedItem;

      const isThereCashPay = (item.paymentDetails || []).filter((ft) => ft.paymentType === 'CASH');
      const isThereCheckPay = (item.paymentDetails || []).filter((ft) => ft.paymentType === 'CHECK');
      const isPaidGreaterThanTotalSum = (amountToNumber(this.totalPaidMain))
      > (amountToNumber(this.totalSum));
      const alternateOverpayment = this.paymentSettingItem.alternateOverpaymentHandling;
      const { allowChangeDueOnCheckPayments } = this.paymentSettingItem;
      const overUnderFeeLimit = amountToNumber(this.taxSettingItem.overUnderLimit);
      const remainBalForLimit = amountToNumber(this.totalPaidMain) - amountToNumber(this.totalSum);
      const isWithinOverUnderLimit = (remainBalForLimit !== 0)
        && (remainBalForLimit >= -(overUnderFeeLimit) && remainBalForLimit <= overUnderFeeLimit);

      this.evaluatePennyRound();

      // cash overpayment always gives physical change back - no over/under alternative
      if (isThereCashPay.length && isPaidGreaterThanTotalSum) {
        const cashChange = amountFormat(amountToNumber(this.totalPaidMain)
        - amountToNumber(this.totalSum));
        this.editedItem.cashChange = cashChange;
        this.showOverUnder = false;
        this.showOverpayment = false;
      } else if (allowChangeDueOnCheckPayments && isThereCheckPay.length && isPaidGreaterThanTotalSum) {
        // County allows change due on checks, but the clerk may still choose Over/Under
        // for this particular check instead of giving change - keep the button available.
        const cashChange = amountFormat(amountToNumber(this.totalPaidMain)
        - amountToNumber(this.totalSum));
        this.editedItem.cashChange = cashChange;
        this.remainingBalance = remainBalForLimit;
        this.showOverUnder = isWithinOverUnderLimit;
        this.showOverpayment = false;
      } else if (alternateOverpayment && isThereCheckPay.length && isPaidGreaterThanTotalSum) {
        // Alternate overpayment handling: show Overpayment button for check overpayments
        this.editedItem.cashChange = 0;
        const remainBal = amountToNumber(this.totalPaidMain) - amountToNumber(this.totalSum);
        this.remainingBalance = remainBal;
        // Re-show the button if no overpayment recorded yet, or if the amount has changed
        const expectedOverpayment = Math.abs(remainBal);
        this.showOverpayment = !this.overpaymentAmt
          || Math.abs(this.overpaymentAmt - expectedOverpayment) > 0.009;
        this.showOverUnder = false;
      } else {
        // use to show and hide over/under payment status
        this.editedItem.cashChange = 0;
        this.showOverpayment = false;
        this.remainingBalance = remainBalForLimit;
        this.showOverUnder = isWithinOverUnderLimit;
      }
    },
    handleTotalChanged(newTotal) {
      // Update the parent's tax details to reflect changes from LargePaymentList
      // The totalSum computed property will automatically recalculate based on taxDetails
      if (this.editedItem.taxDetails && newTotal !== undefined) {
        this.totalPaymentAmount(this.editedItem.totalPaid || 0);
        // Trigger reactivity to ensure totalSum reflects the changes
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    // When the clerk changes/clicks a Payment Info field (payment type, amount, paid by,
    // or the + button), commit any pending "Add Tax Details" row so it isn't lost
    // if the clerk moves on without clicking Add to List.
    handlePaymentFieldActivity() {
      const { largePaymentListRef } = this.$refs;
      if (largePaymentListRef
        && typeof largePaymentListRef.addToList === 'function'
        && largePaymentListRef.hasValidItemsToAdd) {
        largePaymentListRef.addToList();
      }
    },
    handleServerTotalsChanged(serverTotals) {
      // Update server totals from LargePaymentList for accurate display across all pages
      if (serverTotals && serverTotals.totalRecords > 0) {
        this.serverTotalDue = serverTotals.totalDue;
      }
    },
    handleTaxDetailsChanged(updatedTaxDetails) {
      // Update the editedItem.taxDetails with the changes from LargePaymentList
      // This ensures that when the save button is pressed, the upsert API receives the correct data
      if (updatedTaxDetails && Array.isArray(updatedTaxDetails)) {
        // Create a new object to ensure reactivity
        let merged = {
          ...this.editedItem,
          taxDetails: [...updatedTaxDetails],
        };
        // Void All is one-way (the checkbox is disabled once ticked), so no row event - an
        // edit, a newly added row, a selection change - may bring live amounts back into a
        // payment the clerk already voided. Re-voiding is idempotent: commonVoidFunc skips
        // rows that are already void or posted.
        if (merged.isVoid) {
          merged = commonVoidFunc(merged);
          // Deferred: the callers that emit taxDetailsChanged (addToList,
          // handleTaxDetailChanged) go on to rewrite the grid's totals after the emit
          // returns, and would overwrite a synchronous re-seed.
          this.$nextTick(() => this.syncTaxRowsToGrid(merged.taxDetails));
        }
        this.editedItem = merged;
        // Also update the store directly to ensure consistency
        this.setItem([this.baseCrudKey, this.editedItem]);

        // Trigger reactivity to ensure totalSum reflects the changes
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    handleTaxDetailsSelectionChange(selectedItems) {
      // Store selected item IDs to preserve selection across data updates
      this.selectedTaxDetailIds = (selectedItems || []).map((item) => item._id);
      this.hasSelectedTaxDetails = selectedItems && selectedItems.length > 0;

      // Calculate penalty for all selected tax details records based on penalty date
      if (this.hasSelectedTaxDetails) {
        this.calculatePenaltyForSelectedRecords(selectedItems);
      }
    },
    calculatePenaltyForSelectedRecords(selectedItems) {
      const { penaltyDate } = this.editedItem;
      if (!penaltyDate) {
        return; // No penalty date set, skip calculation
      }

      const { penaltyDate: settingPenaltyDate, penaltyRate } = this.taxSettingItem;

      // Update penalty for each selected record
      const updatedTaxDetails = [...this.editedItem.taxDetails];

      selectedItems.forEach((selectedItem) => {
        // Find the index of this item in the tax details array
        const itemIndex = updatedTaxDetails.findIndex((item) => item._id === selectedItem._id);
        if (itemIndex >= 0 && !updatedTaxDetails[itemIndex].posted) {
          const item = updatedTaxDetails[itemIndex];
          const isExemptManufacturing = (item.statusCode || [])
            .includes(exemptManufacturingStatusCode);
          const updatedItem = { ...item };
          const isItAExemptPayment = updatedItem.isExempt;
          let returnedVal = { penaltyAmt: amountFormat(0) };

          if (!isItAExemptPayment && item.totalTax) {
            returnedVal = penaltyCalculation(
              penaltyDate, updatedItem.penaltyStartDate, settingPenaltyDate, updatedItem.totalTax,
              updatedItem.totalPaid, 0, penaltyRate, updatedItem.taxTotalDue,
              updatedItem.taxYear, (item.statusCode || []), this.taxSettingItem,
            );

            updatedItem.penaltyAmt = amountFormat(returnedVal.penaltyAmt);

            // Update feelist based on effective date if needed
            let totalFee = updatedItem.totalFees;
            if ((updatedItem.allFeesList || []).length && !isExemptManufacturing) {
              const { feeDet, feesAmt } = getFeeListBasedOnEffeciveDate(
                updatedItem.allFeesList, penaltyDate,
              );
              totalFee = feesAmt;
              updatedItem.fees = feeDet;
              updatedItem.initialFees = feeDet;
            }
            updatedItem.totalFees = isExemptManufacturing ? 0 : amountFormat(totalFee);

            // Update total amount
            const totalCalcAmt = amountToNumber(returnedVal.penaltyAmt)
              + amountToNumber(updatedItem.taxAmt) + amountToNumber(totalFee);
            updatedItem.total = amountFormat(totalCalcAmt || 0);

            // Update the item in the array
            updatedTaxDetails[itemIndex] = updatedItem;
          }
        }
      });

      // Update the tax details array
      this.editedItem.taxDetails = updatedTaxDetails;
      this.$forceUpdate();
    },
    preserveSelectionState() {
      // Restore selection state for tax details based on stored IDs
      if (this.editedItem.taxDetails) {
        this.editedItem.taxDetails.forEach((item) => {
          // Set selected to true only if the item ID is in the stored list
          // Set selected to false if the item ID is NOT in the stored list
          // eslint-disable-next-line no-param-reassign
          item.selected = this.selectedTaxDetailIds.includes(item._id);
        });
        // Update the hasSelectedTaxDetails flag
        this.hasSelectedTaxDetails = this.selectedTaxDetailIds.length > 0;
      }
    },
    clearAllSelections() {
      // Clear all selections
      this.selectedTaxDetailIds = [];
      this.hasSelectedTaxDetails = false;
      if (this.editedItem.taxDetails) {
        this.editedItem.taxDetails.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.selected = false;
        });
      }
    },
  },
  watch: {
    'editedItem.payDate': function payDateWatcher(val) {
      this.checkPayDateFiscalYear(val);
    },
    isVisibleProp: {
      handler(newVal) {
        if (newVal) {
          // to force re-render the total paid field when the dialog is opened or closed
          this.changeKeyOnDialog += 1;
          // Sync totalPaidMain and recalc cashChange from editedItem when dialog opens
          // (e.g. 2nd+ open: list row may not have cashChange; totalPaymentAmount sets it)
          this.$nextTick(() => {
            if (this.editedItem && (this.editedItem._id || this.editedItem.paymentNumber != null)) {
              this.totalPaymentAmount(this.editedItem.totalPaid || 0);
            }
          });
        } else {
          this.changeKeyOnDialog = 1;
        }
      },
    },
    'editedItem.overUnderStatus': {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          this.showOverUnder = true;
        } else {
          this.showOverUnder = false;
        }
      },
    },
    'editedItem.taxDetails': {
      handler() {
        // Preserve selection state when tax details are updated
        this.$nextTick(() => {
          this.preserveSelectionState();
          // The total due just moved, so the nickel check has to be redone. Only the
          // showPennyRound flag is touched here - nothing inside editedItem - so this cannot
          // re-trigger the deep watcher it runs from.
          this.evaluatePennyRound();
        });
      },
      deep: true,
    },
    // Penny Round keys off the payment TYPE, but dialogPaymentDetails only emits
    // totalPaymentAmount from a computed that depends on each line's `amount`. Picking CASH on
    // a line that already has an amount (or none yet) moves no amount, so without this the
    // button would not appear until something unrelated changed. Sets only showPennyRound.
    'editedItem.paymentDetails': {
      handler() {
        this.evaluatePennyRound();
      },
      deep: true,
    },
    // Reset serverTotalDue when payment changes to ensure fresh calculation
    'editedItem.paymentNumber': {
      handler() {
        this.serverTotalDue = null;
      },
    },
    // Check if we're using dialogTaxDetails (not LargePaymentList) and reset serverTotalDue
    baseCrudKey: {
      handler(newVal) {
        // For non-picklist modes with paymentNumber === 0, we use dialogTaxDetails
        // which calculates totals locally, so reset serverTotalDue
        if (newVal !== 'pickListMakePaymentDialog'
          && (this.editedItem.paymentNumber || 0) === 0) {
          this.serverTotalDue = null;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.row {
  margin: -1.4rem !important;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.payment-dialog-content {
  border: 1px solid lightgray;
  padding: 1rem 0.5rem 0rem 0.5rem;
}
.large-payment-wrapper {
  width: 100%;
  margin-top: 0.3rem;
  clear: both;
  overflow: hidden;
}
.large-payment-wrapper >>> .v-container {
  max-width: 100%;
  padding: 0;
}
.large-payment-wrapper >>> .elevation-3 {
  margin: 0.5rem 0 !important;
}
</style>
